import { object, string } from "@scalar/validation";
//#region src/entities/tools/ask-for-authentication.ts
var ASK_FOR_AUTHENTICATION_TOOL_NAME = "ask-for-authentication";
var askForAuthenticationInputSchema = object({
	documentName: string(),
	uniqueIdentifier: string({ typeComment: "Needed for legacy support for old clients" })
});
//#endregion
export { ASK_FOR_AUTHENTICATION_TOOL_NAME, askForAuthenticationInputSchema };

//# sourceMappingURL=ask-for-authentication.js.map